/*
 * @version: V1.0.0
 * @Date: 2023-10-27 16:50:49
 * @LastEditors: lzq
 * @LastEditTime: 2023-10-27 17:32:39
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\store\index.js
 * @Descripttion:
 */
import Vue from 'vue'
import Vuex from 'vuex'
import tagsView from './modules/tagsView'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    deviceIp: '',
    sidebarRoutes: [],
    pathActive: sessionStorage.getItem('pathActive'),
  },
  mutations: {
    PATH_ACTIVE: (state, pathActive) => {
      sessionStorage.setItem('pathActive', pathActive)
      state.pathActive = pathActive
    },
    setDeviceIp(state, deviceIp) {
      state.deviceIp = deviceIp
    },
    setSidebarRoutes(state, sidebarRoutes) {
      state.sidebarRoutes = sidebarRoutes
    }
  },
  getters: {
    getDeviceIp: state => state.deviceIp,
    visitedViews: (state) => state.tagsView.visitedViews,
    cachedViews: (state) => state.tagsView.cachedViews,
  },
  actions: {

  },
  modules: {
    tagsView,
    user
  },
})
